/**
 * `AudioPort`（索引 Issue #498 の段階 4）— **音のきっかけを鳴らす**。
 *
 * | メソッド | 中身 |
 * |---|---|
 * | `schedule(cues, opts)` | `cues.js` の一覧を受けて鳴らす予約をする |
 * | `stop()` | 予約を捨てる（止めた・シークした） |
 * | `status()` | `{ ready, error }` |
 *
 * 何をいつ鳴らすかは**コアが決める**（帯を動かせば音も付いてくる）。ここは鳴らす手段だけ
 * （プレビューは Web Audio、書き出しは ffmpeg に渡す一覧）。
 */
import { definePort } from './define';

export const AudioPort = definePort('AudioPort', {
  schedule: () => {},
  stop: () => {},
  status: () => ({ ready: true, error: null }),
});
